import WeaveUi from './weave-ui';

let instance = null;

export default class Datepicker extends WeaveUi {

    constructor() {
        super();
        if (!instance) {
            instance = this;
        }
        this.$datepickerElements = {
            header: $('<span class="weave-widget weave-datepicker weave-header"></span>'),
            pickerWrap: $('<span class="weave-picker-wrap weave-state-default"></span>'),
            input: $('<input class="weave-input" placeholder="" name=""/>'),
            icon: $('<span class="weave-select"><span class="weave-icon weave-icon-calendar"></span></span>')
        }

        this.$datepickers = $('input[data-weave-ui-type="date"]');
        this.init();
        return instance;
    }

    init() {
        var that = this;
        this.$datepickers.each(function(index) {
            var $this = $(this);
            var $newDatepicker = that.$datepickerElements.header.clone();
            $this.hide();
            that.buildDatepicker($this, $newDatepicker);
            that.events();
        });
    }

    buildDatepicker($this, $newDatepicker) {
        "use strict";
        var $thisClone = $this.clone();
        $this.replaceWith($newDatepicker);
        $newDatepicker.append(this.$datepickerElements.pickerWrap.clone());
        this.$datepickerElements.input.attr('name', $this.attr('name'));
        this.$datepickerElements.input.attr('placeholder', $this.attr('placeholder'));
        $newDatepicker.find('.weave-picker-wrap').append($this.clone().addClass('weave-input').show());
        $newDatepicker.find('.weave-picker-wrap').append(this.$datepickerElements.icon.clone());
        $newDatepicker.find('.weave-picker-wrap').append($thisClone);
        $newDatepicker.attr('data-id', super.randomString(32));
        this.initDatepicker($newDatepicker.find('.weave-input'));
    }

    initDatepicker($this) {

        function setValueFromBoundInput(input, $this) {
            var contents = $this.val();
            if (input != undefined) {
                contents = input; //optionally passing in a value;
            }

            if ($this.val()) {
                var components = $this.val().split("/");
                $this.val(components[0] + "/" + components[1] + "/" + components[2]);
            } else {
                $this.val('');
            }
        }

        let minDate = $this.attr('min');
        minDate = minDate ? minDate : null;
        let maxDate = $this.attr('max');
        maxDate = maxDate ? maxDate : null;

        $this.datepicker({
            inline: true,
            dateFormat: 'dd/mm/yy',
            onSelect: function(dateText, inst) {
                if (dateText !== inst.lastVal) {
                    $(this).change();
                }
                setValueFromBoundInput(dateText, $this);
            },
            minDate: minDate,
            maxDate: maxDate
        });

    }

    events() {
        $('.weave-icon.weave-icon-calendar').click(function() {
            var $this = $(this);
            $this.parent().prev('input').datepicker('show');
        });
    }
}


// WEBPACK FOOTER //
// ./js/weave-ui/datepicker.js